<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import { Navigation } from 'swiper/modules';
import type { Swiper as SwiperClass } from 'swiper/types';
import IconButton from '@ui/components/icons/IconButton.vue';
import { AngleLeft, AngleRight } from '@ui/icons/filled';

withDefaults(defineProps<{
  items?: Date[];
  initial?: number;
  min?: number;
  max?: number;
}>(), {
  items: () => [],
  initial: 0,
});

const modules = [Navigation];

defineSlots<{
  default?(props: { item: Date }): void;
}>();

const slideNumber = defineModel<number>('index', { default: 0,  });

function updateSlideNumber(swiper: SwiperClass) {
  if (isNaN(swiper.realIndex) || swiper.realIndex === slideNumber.value) return;
  slideNumber.value = swiper.realIndex;
}

const swiper = ref<SwiperClass>();

watch(slideNumber, () => {
  swiper.value?.slideTo(slideNumber.value, 200);
});
</script>

<template lang="pug">
.flex
  IconButton.prev-month.s-32.p-8(:name="AngleLeft" :disabled="min && slideNumber <= min")
  Swiper.swiper.w-100p.h-32(
    :slidesPerView="3"
    :navigation="{prevEl: '.prev-month', nextEl: '.next-month'}"
    :modules="modules"
    :centeredSlides="true"
    :initialSlide="initial"
    :allowSlidePrev="!min || min < slideNumber"
    :allowSlideNext="!max || slideNumber < max"
    :slideToClickedSlide="true"
    @transitionEnd="updateSlideNumber"
    @swiper="swiper = $event"
  )
    SwiperSlide.swiper-slide.br-8(v-for="item of items" :key="item" v-slot="{ isActive }")
      slot(:item="item" :isActive="isActive")
  IconButton.next-month.s-32.p-8(:name="AngleRight" :disabled="max && max <= slideNumber")
</template>

<style scoped lang="scss">
.swiper-slide {
  display: flex;
  transition: .3s ease-in-out;
  transition-property: background, color;

  &:hover {
    background: #F8F8F9;
  }
}
</style>